export default "__VITE_ASSET__BWEKDCFL__"